import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton'
import ListItemAvatar from '@mui/material/ListItemAvatar';
import Avatar from '@mui/material/Avatar';
import Typography from '@mui/material/Typography';
import CommentIcon from '@mui/icons-material/Comment';
import IconButton from '@mui/material/IconButton';

export default function AvatarList({ items, action, selected }) {
  return (
    <List sx={{ width: '100%', bgcolor:'background.paper', pt:0, mt:0 }}>
      {items.map((item) => (
        <>
          <ListItemButton 
          alignItems="flex-end" 
          sx={{p:3, background: selected===item.id ? '#4e71a5':'none'}}
          onClick={()=> action && action(item.id)}

          >
            <ListItemAvatar sx={{ml:{xs:0, sm:3}}}> 
              <Avatar alt={item.title} src="/static/images/avatar/1.jpg" />
            </ListItemAvatar>
            <ListItemText
              primary={item.title}
              secondary={
                <React.Fragment>
                  <Typography
                    component="span"
                    variant="body2"
                    sx={{ color: 'text.primary', display: 'inline' }}
                  >
                    {item.subtitle}
                  </Typography>
                  {item.details}
                </React.Fragment>
              }
            />
          </ListItemButton>
          <Divider variant="" component="li" />
        </>
      ))}

    </List>
  );
}